import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TranslateModule} from '../../translate/translate.module';

@NgModule({
  declarations: [],
  exports: [],
  imports: [
    CommonModule,
    TranslateModule
  ],
  providers: []
})
export class MockModule { }
